import { lang, commonLang } from '@umu/ukit-lang';
/**
 * @description
 */

import './userCommentRole.scss';

import React from 'react';

import { components } from 'common';
const { If } = components;

import { ROLE, CommentParentType, IPlainData } from '@umu/umu-types';

const LEARNING_CIRCLE_ROLE: IPlainData = {
    1: lang('圈主'),
    2: lang('管理员'),
    3: lang('嘉宾'),
    4: '',
};

export interface IProps {
    role: ROLE;
    roleName?: string;
    type?: CommentParentType;
}

export function UserCommentRole(props: IProps) {
    const { role, roleName } = props;
    if (!props.role) {
        return null;
    }
    let name = roleName || commonLang('讲师');
    if (props.type === CommentParentType.LEARNING_CIRCLE_COMMENT) {
        name = LEARNING_CIRCLE_ROLE[role];
    }
    return (
        <If condition={!!name}>
            <span className="user-name-role">{name}</span>
        </If>
    );
}
